<template>
 <b-overlay
    :show="isOnLoad"
    variant="dark"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
  >
      <!--UPLOAD-->
      <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isFailed">
        <div class="dropbox" :class="{ 'dropbox-error': isFailed }">
          <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
            :accept="uploadAccept" class="input-file">
            <div class="dropboxVisual">
              <div class="dropboxIconWrap">
                <b-icon :icon="isFailed ? 'exclamation-triangle-fill' : (isSaving ? 'cloud-upload-fill' : 'images')" class="dropboxIcon"></b-icon>
              </div>
              <div class="dropboxTitle" v-if="isInitial">
                Cliquez ici ou glissez vos fichiers dans cette zone
              </div>
              <div class="dropboxTitle" v-if="isSaving">
                Envoi en cours de {{ fileCount }} fichier<span v-if="fileCount > 1">s</span>
              </div>
              <div class="dropboxTitle dropboxTitle-error" v-if="isFailed">
                {{ uploadError || "Une erreur s'est produite pendant l'envoi." }}
              </div>
              <div class="dropboxHint" v-if="isInitial">
                Formats acceptés : {{ uploadAcceptLabel }}. Le traitement s'applique automatiquement après l'envoi.
              </div>
              <div class="dropboxHint" v-if="isSaving">
                Merci de patienter quelques secondes pendant la préparation des fichiers.
              </div>
              <div class="dropboxHint" v-if="isFailed">
                Corrigez puis réessayez. La fenêtre reste ouverte pour vous laisser continuer.
              </div>
            </div>
        </div>
      </form>
      </b-overlay>
</template>

<script>
  // swap as you need
  //import { upload } from './file-upload.fake.service'; // fake service
  // import { upload } from './file-upload.service';   // real service
  //import { wait } from './utils';

  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  import axios from 'axios'
  export default {
    name: 'uploader',
    props: {
      payload: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        isOnLoad: false,
        fileCount: 0,
        uploadedFiles: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'files[]'
      }
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      uploadAccept() {
        return this.payload.acceptTypes || 'image/*';
      },
      uploadAcceptLabel() {
        return this.uploadAccept === 'application/pdf' ? 'PDF' : 'images';
      }
    },
    methods: {
      reset() {
        // reset form to initial state
        this.isOnLoad = false;
        this.currentStatus = STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
      },
      save(formData, maxReached = false) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING;

        axios.post(
          '/api/folders/upld/'+this.payload.folderClientInfo.folderName+'/'+this.payload.maxUploadCount,
          formData,
          this.__.buildRequestConfig()
        )
        .then((res)=>{
            this.uploadedFiles = [].concat(res.data);
            this.currentStatus = STATUS_SUCCESS;
            this.$props.payload.onUploadSuccess(res.data);
            this.reset();
            if(maxReached) {
              this.$props.payload.onMaxReached();
            }
        })
        .catch((error) => {
            this.uploadError = error?.response?.data?.message || "Une erreur s'est produite pendant l'envoi.";
            this.currentStatus = STATUS_FAILED;
            this.isOnLoad = false;
            if (typeof this.$props.payload.onUploadFail === 'function') {
              this.$props.payload.onUploadFail(error);
            }
        })

        // this.__.uploadFolderContent({
        //   onNext: (data)=>{
        //     this.uploadedFiles = [].concat(data);
        //     this.currentStatus = STATUS_SUCCESS;
        //     this.$props.__payload.onUploadSuccess(data);
        //     this.reset();
        //   },
        //   onComplete: (data) => {},
        //   onError: () => {
        //     this.uploadError ='Une erreur est produite';
        //     this.currentStatus = STATUS_FAILED;
        //     this.$props.__payload.onUploadFail();
        //     this.reset();
        //   },
        //   data: formData,
        // })
      },
      filesChange(fieldName, fileList) {
        this.isOnLoad = true;
        // handle file changes
        const formData = new FormData();
        const uploadOptions = this.payload.uploadOptions || {};
        //formData.append('____', this.$props.__payload.folder);
        if (!fileList.length) {
          this.isOnLoad = false;
          return;
        }
        Object.entries(uploadOptions).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            formData.append(key, value);
          }
        });
        // append the files to FormData
        let freeSize = this.$props.payload.folderClientInfo.freeSizeOcte;
        let maxReached = false
        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            freeSize -= fileList[x].size; 
            if(freeSize > 0) {
              formData.append("files", fileList[x], fileList[x].name);
            } else {
              maxReached = true;
            }
            
          });
        //formData.append(fieldName, a);
        // save it
        this.save(formData, maxReached);
      }
    },
    mounted() {
      this.reset();
    },
  }

</script>

<style lang="scss">
  .dropbox {
    position: relative;
    padding: 12px;
    border-radius: 20px;
    background: linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
    border: 1px solid #dbe4f0;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
    color: #475569;
    overflow: hidden;
  }

  .dropbox::before {
    content: "";
    position: relative;
    display: block;
    min-height: 0;
  }
  
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    cursor: pointer;
    z-index: 3;
  }
  
  .dropbox:hover {
    background: linear-gradient(180deg, #ffffff 0%, #eff6ff 100%);
    border-color: #bfdbfe;
  }

  .dropbox-error {
    background: linear-gradient(180deg, #fff7f7 0%, #fff1f2 100%);
    border-color: #fecaca;
  }

  .dropboxVisual {
    min-height: 220px;
    padding: 28px 20px;
    border: 2px dashed #94a3b8;
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 10px;
    background:
      radial-gradient(circle at top, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.35)),
      linear-gradient(180deg, rgba(255, 255, 255, 0.78), rgba(248, 250, 252, 0.9));
  }

  .dropbox-error .dropboxVisual {
    border-color: #fca5a5;
  }

  .dropboxIconWrap {
    width: 62px;
    height: 62px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%);
    box-shadow: 0 16px 28px rgba(37, 99, 235, 0.22);
  }

  .dropbox-error .dropboxIconWrap {
    background: linear-gradient(135deg, #ef4444 0%, #fb7185 100%);
    box-shadow: 0 16px 28px rgba(239, 68, 68, 0.2);
  }

  .dropboxIcon {
    color: #fff;
    font-size: 1.7rem;
  }

  .dropboxTitle {
    max-width: 680px;
    color: #1e293b;
    font-size: 1.15rem;
    font-weight: 700;
    line-height: 1.4;
  }

  .dropboxTitle-error {
    color: #b91c1c;
  }

  .dropboxHint {
    max-width: 720px;
    color: #64748b;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  @media (max-width: 767px) {
    .dropboxVisual {
      min-height: 180px;
      padding: 22px 14px;
    }

    .dropboxTitle {
      font-size: 1rem;
    }

    .dropboxHint {
      font-size: 0.88rem;
    }
  }
</style>
